<template>
    <div class="add-form">
        <el-dialog
            v-model="dialogVisible"
            :title="title"
            width="40%"
            :before-close="handleCloseClick"
        >
            <el-form ref="form" :model="Dform" :rules="rules" label-width="100px" >
            <el-row>
                <el-form-item label="所属用户" prop="region">
                    <el-select v-model="Dform.region" placeholder="请选择所属用户" @visible-change='suoshuVisibleChange'>
                    <el-option :label="item.name" :value="item.id" v-for="item in regionList"  :key="item.value" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设置密码" >
                    <el-input v-model="Dform.setPassword" type="password" ></el-input>
                </el-form-item>
                
            </el-row>
            <el-row>
    
                <el-form-item label="IMEI" prop="imei">
                    <el-input v-model="Dform.imei"  :disabled="title=='修改终端'" ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" >
                    <el-input v-model="Dform.confirmPassword" type="password" ></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="型号" prop="model">
                    <el-select v-model="Dform.model" filterable placeholder="请选择设备型号">
                    <el-option :label="item.name" :value="item.id" v-for="item in dictionaryNameList" :key="item.value" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="RFID" >
                    <el-input v-model="Dform.rfid" placeholder="请输入十进制的rfid"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="姓名" >
                    <el-input v-model="Dform.name"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" >
                    <el-input v-model="Dform.cardId"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="号码" >
                    <el-input v-model="Dform.phoneNumber"></el-input>
                </el-form-item>
                <el-form-item label="PEN MAC" >
                    <el-input v-model="Dform.PENMAC"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="激活时间" >
                    <el-date-picker
                        v-model="Dform.started"
                        type="datetime"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="到期时间" >
                    <el-date-picker
                        v-model="Dform.expirationTime"
                        type="datetime"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-row>
            <el-row class="ROPESKIPPING">
                <el-form-item label="ropeSkippingMac"  >
                    <el-input v-model="Dform.bluetoothMac"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="性别" >
                    <el-radio-group v-model="Dform.sex">
                        <el-radio label="男" ></el-radio>
                        <el-radio label="女" ></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-row>
            </el-form>
            <!-- <span>This is a message</span> -->
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="handleCloseClick">返回</el-button>
                    <el-button type="primary" @click="submitForm('form')">
                    提交
                    </el-button>
                </span>
            </template>
            <userArea v-if="userAreaShow" @handleClose='handleClose' @singleSelectionClick="singleSelectionClick"></userArea>
        </el-dialog>
    </div>
</template>

<script>
import userArea from '@/components/userArea/index.vue';
import { updateInfo,menuGetUserTree,deviceAdd,menuGetRTree ,GetDeviceTree,userTree} from '@/assets/api/api'
export default {
    props: ['detailsObj'],
    components: {
        userArea
    },
    data() {
     var validatePass = (rule, value, callback) => {
        console.log(rule, value, callback,8888888);
        if (value == 352273017386340) {
          return callback(new Error('禁止初始IMEI号导入'));
        }else{
            callback();
        }
      };
        return {
            title: '',
            Dform: {
                name: '',
                imei:'',
                region: '',
                model: '',
                setPassword: '',
                phoneNumber:'',
                confirmPassword: '',
                rfid:'',
                cardId:'',
                number:'',
                PENMAC:'',
                ROPESKIPPING:'',
                sex:'',
                started:'',
                expirationTime:'',
                bluetoothMac:'',
            },
            numberImei:352273017386340,
            rules: {
                imei: [
                    { required: true, message: '请输入IMEI', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' },
                ],
                region: [
                    { required: true, message: '请选所属用户', trigger: 'change' }
                ],
                model: [
                    { required: true, message: '请选择型号', trigger: 'change' }
                ],
            },
            dialogVisible: true,
            dictionaryNameList: [],
            regionList: [],
            treeData:[],
            userAreaShow: false,
        };
    },
    created() {
        this.menuGetRTree()
    },
    mounted() {
       console.log(this.detailsObj);
       if ( JSON.stringify(this.detailsObj) != '{}' ) {
            console.log('修改');
            this.title= '修改终端'
            this.Dform.PENMAC = this.detailsObj.penMac  || '' // 身份证号
            this.Dform.bluetoothMac = this.detailsObj.bluetoothMac  || '' // 身份证号

            this.Dform.cardId = this.detailsObj.cardId  || '' // 身份证号
            this.Dform.imei = this.detailsObj.imei  || '' // IMEI
            this.Dform.phoneNumber = this.detailsObj.phoneNumber  || '' // 号码
            this.Dform.name = this.detailsObj.deviceName  || '' // 设备名称
             this.Dform.started  = this.detailsObj.started  || ''  // 激活时间
             this.Dform.rfid = this.detailsObj.rfidDecimal || '' // RFID
             this.Dform.sex = this.detailsObj.sex==0? '女':'男' // 性别 0女，1男
             this.Dform.expirationTime  = this.detailsObj.expirationTime || '' // 到期时间

            //  this.dictionaryNameList = [ { 
            //     label: this.detailsObj.dictionaryName || '',
            //     value: this.detailsObj.dictionaryName || '',
            //  }]
            this.Dform.model = this.detailsObj.dictionaryId || '' // 到期时间
            // this.Dform.region = this.detailsObj.userId || '' // 
            this.Dform.region = this.detailsObj.userId // 
            this.regionList = [ { name:this.detailsObj.userAlias || this.detailsObj.userName, id: this.detailsObj.userId }]
            console.log(this.regionList,'修改--所属用户-回显');
       } else {
            console.log('新增');
            this.title= '新增终端'
            this.menuGetUserTreeGet() // 原所所属用户列表接口
            
       }
    },
    methods: {
        suoshuVisibleChange (){
            this.userAreaShow= true
        },
        singleSelectionClick (item) {
            this.regionList = [item]
            this.Dform.region = item.id
            this.userAreaShow= false
            console.log(item,item.name,'单选');
        },
        handleClose () {
            this.userAreaShow = false 
        },
        handleCloseClick() {
            this.$emit('AddShowClick')
        },
        submitForm(formName) {
            console.log(this.Dform,this.title);
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.jiayanTongguo()
            } else {
                console.log(valid,'校验未通过');
                return false;
            }
            });
        },
        jiayanTongguo() {
            if( this.title == '修改终端') {
                this.updateInfoCLick()
            } else if( this.title == '新增终端'){
                this.AddInfoCLick()
            }
        },
        menuGetRTree() {
            let params = {
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            
            GetDeviceTree(params).then((res)=> {
                console.log(res,'获取--型号下拉框sln1111111');
                this.dictionaryNameList =  res.data.data.dictionaryList

            }).catch((err)=> {
                console.log(err);
            })
            // menuGetRTree(params).then((res)=> {
            //     console.log(res,res.data.data.children,'获取--型号下拉框');
            //     this.dictionaryNameList =  res.data.data.children
            // }).catch((err)=> {
            //     console.log(err);
            // })
        },
        menuGetUserTreeGet() {
       
            const params = {
                userId: JSON.parse(localStorage.getItem('user')).id
            };
            userTree(params).then((res) => {
                console.log(res, 123456);
                // this.userTrData = res.data.data
                this.regionList = res.data.data
                this.regionList.forEach((item,index) => {
                    item.name = item.alias ||item.siteName ||item.circleName ||item.username ||item.label
                })
                this.Dform.region = res.data.data[0].id
            }).catch((err) => {
                console.log(err);
            })
        },
        AddInfoCLick () {
            console.log('新增',7889999);
            let params = {
                cardId: this.Dform.cardId,
                deviceName: this.Dform.name,
                dictionaryId: this.Dform.model,
                // dictionaryId: '',
                expirationTime: this.Dform.expirationTime,
                imei: this.Dform.imei,
                lastAck: null, // 最近活跃
                // orgCode: 
                password: this.Dform.setPassword,
                rePassword: this.Dform.confirmPassword,
                penMac: this.Dform.PENMAC,
                phoneNumber: this.Dform.phoneNumber,
                rfidDecimal: this.Dform.rfid,
                // ropeSkippingMac: , // 跳绳蓝牙网关
                sex: this.Dform.sex=='女'?'0':'1',
                userId: this.Dform.region,
                ropeSkippingMac: this.Dform.bluetoothMac,
                started: this.Dform.started,
                // userId: JSON.parse(localStorage.getItem('user')).id,
                // userId: JSON.parse(localStorage.getItem('user')).id,
            }
            deviceAdd(params).then((res)=> {
                console.log(res,'修改设备接口');
                this.handleCloseClick()
            }).catch((err)=> {
                console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },  
        updateInfoCLick() {
            console.log(this.Dform.region,88888);
            // if ( this.Dform.region == this.detailsObj.userName) {
            //     for (let )
            // }
            let params = {
                penMac:this.Dform.PENMAC,
                userId: this.Dform.region,
                ropeSkippingMac: this.Dform.bluetoothMac, // 蓝牙MAC
                cardId: this.Dform.cardId,
                deviceId: this.detailsObj.deviceId, // 设备id
                deviceName: this.Dform.name,
                devicePassword: '', // 设备密码
                dictionaryId: this.Dform.model,
                expirationTime: this.Dform.expirationTime,
                imei: this.Dform.imei,
                lastAck: this.detailsObj.lastAck, // 最近活跃
                phoneNumber: this.Dform.phoneNumber,
                rePassword: this.Dform.confirmPassword,
                rfidDecimal: this.Dform.rfid,
                sex: this.Dform.sex=='女'?'0':'1',
                started: this.Dform.started,
                // userId: JSON.parse(localStorage.getItem('user')).id,
                // userName: this.Dform.region,
            }
            updateInfo(params).then((res)=> {
                console.log(res,'修改设备接口');
                this.handleCloseClick()
            }).catch((err)=> {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        arrayTreeAddLevel (array, levelName = 'level', childrenName = 'children') {
              if (!Array.isArray(array)) return []
                       const recursive = (array, level = 0) => {
                       level++
                       return array.map(v => {
                            v[levelName] = ''
                       // for( let value     )
                       for (var i = 0; i < level; i++){
                                     v[levelName] = v[levelName] + ' ——'
                       }
                       // level.forEach(item=> {
                       // })
                       const child = v[childrenName]
                       if (child && child.length) recursive(child, level)
                            return this.treeData.push(v) 
                       })
                       }
              return recursive(array)
              },
    },
};
</script>

<style scoped lang="scss">
/deep/ {
    .el-dialog__body {
        // height: 75%;
        max-height: 400px;
        // min-height: 350px;        
        overflow: auto;
    }
    // .el-form {
    //     height: ;
    //     overflow: auto;
    //     background-color: red;
    // }
    .el-input--small {
        width: 250px;
    }
    .el-select .el-input__inner {
        height: 35px !important;
        line-height: 35px !important;
    }
    .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
    }
    .el-input__inner {
        height: 35px;
        line-height: 35px; 
    }
    .el-radio.el-radio--small .el-radio__inner {
        width: 14px;
        height: 14px;
    }
    .el-input__wrapper {
        height: 35px;
        line-height: 35px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__wrapper {
        height: 35px !important;
    }
    .el-select--small .el-select__wrapper{
        width: 250px;
        height: 37px;
    }
}
.ROPESKIPPING {
    /deep/ {
        .el-form-item--small .el-form-item__label {
            line-height: 18px;
        }
    }
}
</style>
